export default {
  name: 'KCard',
  props: {
    heading: {
      type: String,
    },
    variant: {
      type: String,
    },
    wrapHeading: {
      type: Boolean,
    },
    longerHeading: {
      type: Boolean,
    },
    smaller: {
      type: Boolean,
    },
    padInside: {
      type: Boolean,
    },
  },
  computed: {
    inModal() {
      return this.variant === 'in-modal';
    },
  },
};
